import { render, staticRenderFns } from "./QuickReplies.vue?vue&type=template&id=633e1d1c&"
import script from "./QuickReplies.vue?vue&type=script&lang=js&"
export * from "./QuickReplies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports